import {
	createStore,
	createContainer,
	createActionsHook,
	createHook,
	type StoreActionApi,
	createStateHook,
} from 'react-sweet-state';
import type { IntentTemplate } from '../../common/types';
import type { State } from './types';

const initialState: State = {
	id: undefined,
	name: undefined,
	description: undefined,
	questions: undefined,
	type: undefined,
	isDirty: undefined,
	cancelQuestionsRequest: null,
};

const doCancelQuestionsRequest = (state: State) =>
	state.cancelQuestionsRequest && state.cancelQuestionsRequest();

const actions = {
	setIntentTemplate:
		(template: IntentTemplate) =>
		({ setState }: StoreActionApi<State>) => {
			setState({
				...template,
				isDirty: false,
			});
		},
	setQuestions:
		(questions?: readonly string[]) =>
		({ setState }: StoreActionApi<State>) => {
			setState({ questions });
		},
	setDirty:
		() =>
		({ setState }: StoreActionApi<State>) => {
			setState({
				isDirty: true,
			});
		},

	clearIntentTemplate:
		() =>
		({ setState, getState }: StoreActionApi<State>) => {
			doCancelQuestionsRequest(getState());
			setState({
				...initialState,
				isDirty: false,
			});
		},
	clearQuestions:
		() =>
		({ setState }: StoreActionApi<State>) => {
			setState({ questions: undefined });
		},
	setCancelQuestionsRequest:
		(cancelQuestionsRequest: (() => void) | null) =>
		({ setState, getState }: StoreActionApi<State>) => {
			doCancelQuestionsRequest(getState());
			setState({ cancelQuestionsRequest });
		},
};

const store = createStore({
	initialState,
	actions,
	name: 'JSMVirtualAgentIntentTemplateStore',
});

export const IntentTemplateContainer = createContainer(store);

export const useIntentTemplateStoreState = createStateHook(store);

export const useIntentTemplateStoreActions = createActionsHook(store);

export const useIsFetchingQuestions = createHook(store, {
	selector: (state) => state.cancelQuestionsRequest !== null,
});
